import { QueryCache, QueryClient } from 'react-query';
import { logger } from '@utils/logger.ts';

export const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache(),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      onError: error => logger.error(error),
    },
    mutations: { onError: error => logger.error(error) },
  },
});
